import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import "./About.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import SubHeader from "../SubComp/SubHeader/SubHeader";

const About = () => {
  const plus = <FontAwesomeIcon icon={faPlus} />;
  return (
    <>
      <Header />

      <SubHeader title="About Us" text='paintings' width='container' />

      {/* Banner section  */}
      <div className="about-content-bg">
        <h1 className="text-center">
          {" "}
          THE WORLD’S LEADING <br /> ONLINE ART GALLERY
        </h1>
      </div>
      {/* End of Banner section  */}

      {/* Featured Art Section  */}
      <div className="about-featured text-white text-center">
        <h1 className="pt-5 pb-4 " style={{ fontSize: "40px" }}>
          Featured Art Collections
        </h1>
        <div className="container">
          <div className="row justify-content-md-center g-0 pb-5">
            <div className="about-f col-lg-4 about-img1 d-flex justify-content-center align-items-end">
              <div className="cursor">
                <h2 className="f-text">Abstract</h2>
                <p className="plus">{plus}</p>
              </div>
            </div>

            <div className="about-f col-lg-4 about-img2 d-flex justify-content-center align-items-end">
              <div className="cursor">
                <h2 className="f-text">Potraits</h2>
                <p className="plus">{plus}</p>
              </div>
            </div>

            <div className="about-f col-lg-4 about-img3 d-flex justify-content-center align-items-end">
              <div className="cursor">
                <h2 className="f-text">Landscapes</h2>
                <p className="plus">{plus}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* End of Featured section  */}

      {/* Client Logo section  */}
      <div className="client-logo">
        <h1 className="text-center pt-5 mt-5">
          A list of our Favourite People
        </h1>
        <div className="container">
          <div className="row g-5 p-5 m-5">
            <div className="col-3">
              <img
                src={require("../../Asset/client logo/Company Logo (1).png")}
                alt="Client Logo" className='cursor'
              />
            </div>
            <div className="col-3">
              <img
                src={require("../../Asset/client logo/Company Logo (2).png")}
                alt="Client Logo" className='cursor'
              />
            </div>
            <div className="col-3">
              <img
                src={require("../../Asset/client logo/Company Logo (3).png")}
                alt="Client Logo" className='cursor'
              />
            </div>
            <div className="col-3">
              <img
                src={require("../../Asset/client logo/Company Logo (4).png")}
                alt="Client Logo" className='cursor'
              />
            </div>
            <div className="col-3">
              <img
                src={require("../../Asset/client logo/Company Logo (5).png")}
                alt="Client Logo" className='cursor'
              />
            </div>
            <div className="col-3">
              <img
                src={require("../../Asset/client logo/Company Logo (6).png")}
                alt="Client Logo" className='cursor'
              />
            </div>
            <div className="col-3">
              <img
                src={require("../../Asset/client logo/Company Logo.png")}
                alt="Client Logo" className='cursor'
              />
            </div>
            <div className="col-3">
              <img
                src={require("../../Asset/client logo/logoipsum-logo-27 1.png")}
                alt="Client Logo" className='cursor'
              />
            </div>
          </div>
        </div>
      </div>
      {/* End of Client Logo section  */}

      {/* Best place to visit  */}
      <div className="under500">
        <div className="row gx-0 align-items-center justify-content-center">
          <div className="gx-5 col-lg-6 col-md-6 col-12 text-white p-5 ">

            <div className="bestplace-div">
              <h1 className="mb-3 content">
                THE BEST PLACE TO BUY ART YOU <br /> LOVE
              </h1>
              <p className="mb-4">
                Discover an unparalleled selection of art by <br /> artists from
                around the world to suit all budgets,
                <br /> styles, and spaces.
              </p>
              <h1 className="mb-3 content">
                ACCESS TO KNOWLEDGEABLE <br /> CURATORS
              </h1>
              <p className="mb-4">
                See new curator-approved artworks in special <br /> collections
                released weekly, or work with an art <br /> advisor to get
                personalized recommendations.
              </p>
            </div>
          </div>
          <div className="col-lg-6 col-md-6  col-12 ">
            <div className="under500Img">
              <img src={require("../../Asset/about/Group 130.png")} alt="" />
            </div>
          </div>
        </div>
      </div>

      {/* SUPPORTING EMERGING SECTION  */}
      <div className="under500">
        <div className="row gx-0 align-items-center justify-content-center">
          <div className="col-lg-6 col-md-6  col-12 ">
            <div className="under500Img">
              <img
                src={require("../../Asset/about/Group 130 (1).png")}
                alt=""
              />
            </div>
          </div>
          <div className="gx-5  col-lg-6 col-md-6 my-5 col-12 text-white ps-5 ">
            <div className="merging-div">
              <h1 className="mb-3 content">SUPPORT EMERGING ARTISTS</h1>
              <p className="mb-4">
                We value the talented artists we represent and <br /> pay them
                more on every sale than other <br /> galleries.
              </p>
              <h1 className="mb-3 content">PEACE OF MIND</h1>
              <p className="mb-4">
                Our 7-day 100% money-back guarantee allows <br />
                you to buy with confidence. If you’re not <br />
                satisfied with your purchase, return it and we’ll <br /> help
                you find a work you love.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ENd of emerging section */}

      {/* Curated section  */}
      <div className="curated-container">
        <div className="row gx-0  p-5 align-items-center justify-content-center">
          <div className="gx-5 col-lg-6 col-md-6 my-5 col-12 text-white p-5  ">
            <div className="bestplace-div">
              <h1 className="mb-3 content">Curated Collections</h1>
              <p className="mb-4">
                See new curator-approved works in special <br />
                collections released weekly.
              </p>
              <button
                type="button"
                className="allbutton cl_w px-3 py-2 cl_w"
                onclick="location.href='/'"
              >
                Start Exploring
              </button>
            </div>
          </div>
          <div className="col-lg-6 col-md-6  col-12 ">
            <div className="curated">
              <img src={require("../../Asset/about/side image.png")} alt="" />
            </div>
          </div>
        </div>
      </div>
      {/* End of curated section */}

      {/* Living with art section */}
      <div className="about-living-bg text-white text-center px5">
        <div className="w30 m-auto">
          <h1 className="bold mt-5"> Living With Art</h1>
          <p className="fs20">
            People who have discovered and fallen in love with works through
            Saatchi Art invite us into their homes and share their stories
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default About;
